var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('TableApp', {
    ref: "tabela",
    attrs: {
      "titulo": "Oportunidades",
      "textoBtn": "Nova oportunidade",
      "api-url": "/crm/oportunidades/lista",
      "fields": _vm.fields,
      "fixedLayout": ""
    },
    nativeOn: {
      "!click": function click($event) {
        return _vm.handleTableClick.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field === 'titulo' ? _c('router-link', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary crm-table-link",
          attrs: {
            "to": {
              name: 'crmOportunidadeDetalhe',
              params: {
                id: props.rowData.id_crm_oportunidade
              }
            }
          }
        }, [_vm._v(" " + _vm._s(props.rowData.titulo) + " ")]) : _vm._e()];
      }
    }, {
      key: "toolbar-actions",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-dark font-weight-bolder font-size-sm",
          on: {
            "click": _vm.abrirModal
          }
        }, [_vm._v(" Nova oportunidade ")])];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "crm-oportunidade-modal",
      "title": "Nova oportunidade",
      "ok-title": "Salvar",
      "cancel-title": "Cancelar",
      "ok-disabled": _vm.saving,
      "cancel-disabled": _vm.saving
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "titulo", $$v);
      },
      expression: "form.titulo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Valor estimado"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.valor_estimado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_estimado", $$v);
      },
      expression: "form.valor_estimado"
    }
  }, 'money', _vm.priceOptions, false))], 1), _c('b-form-group', {
    attrs: {
      "label": "Previsão de fechamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.form.previsao_fechamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "previsao_fechamento", $$v);
      },
      expression: "form.previsao_fechamento"
    }
  })], 1), _c('BuscaClienteContato', {
    attrs: {
      "label": "Cliente ou contato"
    },
    on: {
      "criar-contato": _vm.criarContatoRapido
    },
    model: {
      value: _vm.vinculoSelecionado,
      callback: function callback($$v) {
        _vm.vinculoSelecionado = $$v;
      },
      expression: "vinculoSelecionado"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };